<template>
    <CModal :title="title" color="warning" :show.sync="predialModal">
        <CRow>
          <CCol md="12">
            <CInput
              label="Cuenta Predial:"
              :lazy="false"
              :isValid="checkIfValid('predial')"
              :value.sync="$v.form.predial.$model"
              placeholder=""
              invalidFeedback="Este campo es obligatorio."
            />
          </CCol>
        </CRow>
        <template #header>
          <h5 class="modal-title">{{title}}</h5>
          <CButtonClose @click="predialModal = false" class="text-white"/>
        </template>
        <template #footer>
          <CButton @click="predialModal = false" color="secondary">Cancelar</CButton>
          <CButton @click="setPredial" color="warning">Agregar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required} from "vuelidate/lib/validators"

export default {
  name: 'PredialModal',
  props: {

  },
  data () {
    return {
      predialModal: false,
      title: "Cuenta Predial",
      id: 0,
      invoice: false,
      name: 'Cuenta Predial',
      isEdit: false,
      form: {
        predial: ''
      },
      submitted: false,
      uuids: [],
      uuidsOptions: []
    }
  },
  mounted: async function() {

  },
  methods: {
    show (predial) {
      this.predialModal = true;

      this.title = 'Cuenta Predial';

      this.isEdit = false;
      this.submitted = false;
      
      this.form = {
        predial: predial
      };

      this.submitted = false
      this.$v.$reset()
    },
    async setPredial () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;
        
        this.closeModal();
        this.$emit("predial", this.form.predial );
      }
    },
    closeModal () {
      this.predialModal = false;

      this.submitted = false
      this.$v.$reset()
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid)
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      predial: {
        required   
      }
    }
  },
}
</script>